module.exports = __webpack_public_path__ + "img/share-friend.1a603c1d.png";